import { forwardRef, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from '@/common/components/Modal/styles.less';

const StyledModal = (
  {
    className,
    open,
    onClose,
    children,
    overlay,
    overlayClassname,
    zIndex,
    overlayOnClose = true,
  },
  ref
) => {
  const container = useRef(document.createElement('div'));

  useEffect(() => {
    document.querySelector('#portal-root').appendChild(container.current);
    return () => {
      document.querySelector('#portal-root').removeChild(container.current);
    };
  }, []);

  if (!open) return null;

  return ReactDOM.createPortal(
    <>
      {overlay && (
        <div
          className={cx(styles.overlay, overlayClassname)}
          onClick={overlayOnClose ? onClose : undefined}
          style={zIndex ? { zIndex } : undefined}
        />
      )}
      <div
        className={cx(styles.container, className)}
        style={zIndex ? { zIndex } : undefined}
        ref={ref}
      >
        {children}
      </div>
    </>,
    container.current
  );
};

const Modal = forwardRef(StyledModal);

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  overlay: PropTypes.bool,
  collapsed: PropTypes.bool,
  zIndex: PropTypes.number,
};

export default Modal;
